import React from "react";
import { Skeleton } from "@material-ui/lab";

const OrderPackagesSkeleton = () => {
  return (
    <div
      className={'flex flex-col gap-4 p-6'}
      style={{
        height: '85vh',
      }}
    >
      <Skeleton variant="rect" animation="wave" height={50} />
      <Skeleton variant="rect" animation="wave" height={50} />
      <Skeleton variant="rect" animation="wave" style={{ flex: '1' }} />
    </div>
  );
};

export default OrderPackagesSkeleton;